import React, { createContext, useContext, useState } from 'react';

const NotificationTableFilterContext = createContext();

export const NotificationTableFilterContextProvider = ({ children }) => {
  const [alertType, setAlertType] = useState({ value: '', label: 'All' });
  const [activeType, setActiveType] = useState({ value: '', label: 'All' });
  const [subscribedTo, setSubscribedTo] = useState(false);

  return (
    <NotificationTableFilterContext.Provider
      value={{ alertType, setAlertType, activeType, setActiveType, subscribedTo, setSubscribedTo }}
    >
      {children}
    </NotificationTableFilterContext.Provider>
  );
};

export const useNotificationTableFilterContext = () => useContext(NotificationTableFilterContext);
